import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { AppSettings } from './../../app.settings';
import { UiService } from '../../services/ui.service';
import { Message, ConfirmationService } from 'primeng/components/common/api';
import { Component, OnInit, OnDestroy } from '@angular/core';
import { StorageService } from './../../services/storage.service';
import { UserCommonService } from './../../services/user-common.service';
import { NotificationsService } from './../../services/notifications.service';
import { CommonBindingDataService } from '../../services/common-binding-data.service';
import { LiveAnnouncer } from '@angular/cdk/a11y';
import { LoaderService } from '../loader/loader.service';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html'
})

export class HeaderComponent implements OnInit, OnDestroy {
  userFullName: string;
  items: any[];
  message: Message[] = [];
  subscription: Subscription;
  notifications: any = [];
  unReadNotificationsCount = 0;
  ariaLabelProfile: any;
  sidebarLabel: boolean;
  ariaLabelCloseSidebar: any;
  ariaLabelOpenSidebar: string;
  userObj: any;

  constructor(
    private uiService: UiService,
    private userCommonService: UserCommonService,
    private router: Router,
    private storageService: StorageService,
    private notificationsService: NotificationsService,
    private confirmationService: ConfirmationService,
    private loaderService: LoaderService,
    private commonBindingDataService: CommonBindingDataService,
    private liveAnnouncer: LiveAnnouncer) {
  }

  ngOnInit() {
    this.sidebarLabel = document.getElementsByTagName('body')[0].classList[0] === 'closed' ? false : true
    this.ariaLabelOpenSidebar = this.commonBindingDataService.getLabel('aria_label_open_sidebar');
    this.ariaLabelCloseSidebar = this.commonBindingDataService.getLabel('aria_label_close_sidebar');
    this.notificationsService.canFetchNotification = true;
    this.userObj = this.storageService.getItem(AppSettings.USER_DETAILS);
    if (this.userObj !== undefined && this.userObj !== null) {
      this.userFullName = this.userObj.firstName + ' ' + this.userObj.lastName;
    }

    this.subscription = this.uiService.profileUpdatedEvent
      .subscribe((state: string) => {
        this.initMenu();
      });

    this.notificationProcessInitialization();

    this.getMetaData();
    this.initMenu();
  }

  onNotifications() {
    this.userCommonService.isNotifications = false;
    this.userCommonService.notificationText = 'Notifications';
    this.getNotificationUnReadCount();
  }

  initMenu() {
    this.items = [
      {
        label: this.userCommonService.notificationText,
        icon: 'fa fa-bell',
        styleClass: this.userCommonService.isNotifications ? 'notification-count' : '',
        routerLink: ['/notifications'],
        command: () => this.onNotifications(),
      },
      {
        label: this.getUserName(),
        icon: 'fa fa-user',
        items: [
          {
            label: 'Profile',
            icon: 'pi pi-fw pi-pencil',
            routerLink: ['/profile'],
          },
          {
            label: 'Logout',
            icon: 'pi pi-fw pi-tags',
            command: () => this.doSignOut(),
          }
        ]
      },
    ];
  }

  getUserName() {
    this.userObj = this.storageService.getItem(AppSettings.USER_DETAILS);
    if (this.userObj !== undefined && this.userObj !== null) {
      return this.userFullName = this.userObj.firstName + ' ' + this.userObj.lastName;
    }
  }

  getMetaData() {
    this.userCommonService.getMetadata().subscribe(
      data => {
        AppSettings.METADATA = data;
        const code = data.tenantConfigs.filter(x => x.configKey === 'country_code');
        if (code.length > 0) {
          AppSettings.COUNTRY_PHONE_CODE = code[0].configValue;
        }
        const currency = data.tenantConfigs.filter(x => x.configKey === 'default_currency');
        if (currency.length > 0) {
          AppSettings.DEFAULT_CURRENCY = currency[0].configValue;
        }
        const country = data.tenantConfigs.filter(x => x.configKey === 'default_country');
        if (country.length > 0) {
          AppSettings.DEFAULT_COUNTRY = country[0].configValue;
        }
        const dateFormat = data.tenantConfigs.filter(x => x.configKey === 'default_date_format');
        if (dateFormat.length > 0) {
          AppSettings.DEFAULT_DATE_FORMAT = dateFormat[0].configValue;
        }
        AppSettings.PASSENGER_TYPES = data.passengerTypes;
        AppSettings.PAYMENT_TYPES = data.paymentTypes;
        AppSettings.TRAVEL_TYPES = data.travelTypes;
        const manageParking = data.tenantConfigs.filter(x => x.configKey === 'manage_parking');
        if (manageParking.length > 0) {
          AppSettings.MANAGE_PARKING = manageParking[0].configValue;
        }

        AppSettings.RESTRICTED_BOOKING_TYPE = data.restrictedBookings;
        this.storageService.setItem(AppSettings.METADATA_KEY, data);
      });
  }

  notificationProcessInitialization() {
    this.notificationsService.startFetchingNotifications(() => {
      this.getNotificationUnReadCount();
    });
  }

  getNotificationUnReadCount() {
    this.unReadNotificationsCount = 0;
    this.notificationsService.getCount(AppSettings.USER_ID, AppSettings.USER_ROLE_ID).subscribe(result => {
      const notificationCount = result.unReadcount;
      if (notificationCount > 0) {
        this.userCommonService.isNotifications = true;
        if (notificationCount > 9) {
          this.userCommonService.notificationText = 'Notifications (9+)';
        } else {
          this.userCommonService.notificationText = 'Notifications (' + notificationCount + ')';
        }
        this.liveAnnouncer.announce(this.commonBindingDataService.getLabel('label_notifications_available'));
        this.initMenu();
      } else {
        this.userCommonService.notificationText = 'Notifications';
        this.userCommonService.isNotifications = false;
        this.initMenu();
      }
    });
  }

  onSideMenuClick(event: any) {
    event.preventDefault();
    document.getElementsByTagName('body')[0].classList.toggle('closed');
    this.sidebarLabel = document.getElementsByTagName('body')[0].classList[0] === 'closed' ? false : true
    this.uiService.sidebarToggled();
  }

  doSignOut() {
    /* this.userCommonService.signOut().subscribe(results => {
      this.storageService.removeAll();
      this.notificationsService.stopFetchingNotifications();
      // this.router.navigate(['/logout']);
      this.router.navigate(['/signin']);
    }, (error) => {
      this.errorMessage(error);
    }); */

    this.confirmationService.confirm({
      message: 'Are you sure you want to log out?',
      accept: () => {
        this.loaderService.show('page-center');
        this.userCommonService.signOut().subscribe(results => {
          this.storageService.removeAll();
          this.notificationsService.stopFetchingNotifications();
          // this.router.navigate(['/logout']);
          // this.router.navigate(['/signin']);  
          window.location.reload();     
        }, (error) => {
          this.errorMessage(error);
        });
      },
      reject: () => {
      }
    });
  }

  ngOnDestroy() {
    this.notificationsService.stopFetchingNotifications();
    this.subscription.unsubscribe();
  }

  errorMessage(error) {
    this.message = [];
    this.message.push({ severity: 'error', summary: 'error', detail: error.general[0].message });
  }
}

